
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { set_current_user, clear_current_user, set_axios_instace, set_cache_instance } from '../actions';

const BASE_PERMISSIONS = { report: 2 }; // TODO: add logic

export default createReducer({
  [set_current_user]:
    (state, payload) => update(state, { user: { $set: { permission: { ...BASE_PERMISSIONS }, ...payload } } }),
  [clear_current_user]:
    (state) => update(state, { user: { $set: undefined } }),
  [set_axios_instace]:
    (state, payload) => update(state, { axios: { $set: payload } }),
  [set_cache_instance]:
    (state, payload) => update(state, { cache: { $set: payload } }),
}, {});
